import { Logger } from '@sitecore-search/common';
import ChoiceRemoveFilterActionHandler from './ChoiceRemoveFilterActionHandler.js';
import RangeRemoveFilterActionHandler from './RangeRemoveFilterActionHandler.js';
const choiceRemoveFilterActionHandler = new ChoiceRemoveFilterActionHandler();
const actionHandlers = {
    range: new RangeRemoveFilterActionHandler(),
    valueId: choiceRemoveFilterActionHandler,
    text: choiceRemoveFilterActionHandler,
};
function handleRemoveFilterAction(query, payload) {
    const { type } = payload;
    const currentActionHandler = actionHandlers[type];
    if (currentActionHandler) {
        currentActionHandler.process(query, payload);
    }
    else {
        Logger.warn(`${type} has not a valid action handler`);
    }
}
export default handleRemoveFilterAction;
